export default __webpack_public_path__ + "static/media/Ballroll_00209.134239d1.png";